export default "__VITE_ASSET__DRO3vglM__"